import { GraphQLClient } from "graphql-request";
import { arbitrum, sepolia } from "viem/chains";

const SLUGS: Record<number, string> = {
  [sepolia.id]: "loan_router_v2_sepolia",
  [arbitrum.id]: "loan_router_v2_arbitrum",
};

export const LOAN_ROUTER_V2_SUBGRAPH_CHAIN_IDS = Object.keys(SLUGS).map(Number);

export function getLoanRouterV2SubgraphClient(chainId: number) {
  const url = `https://api.goldsky.com/api/public/${process.env.GOLDSKY_PROJECT_ID}/subgraphs/${SLUGS[chainId]}/borrow/gn`;
  return new GraphQLClient(url, { headers: { contentType: "application/json" } });
}
